import { Pipe, PipeTransform } from '@angular/core';
import { ErrorType, ErrorMessage } from '@core/enums/form.enum';
import { LocaleService } from '@shared/services/locale.service';

@Pipe({
	name: 'formErrorMessage',
})
export class FormErrorMessagePipe implements PipeTransform {
	constructor(private readonly localeService: LocaleService) {}

	transform<T extends object>(errors: T): string {
		if (!errors) {
			return '';
		}

		return this.getErrorMessage(Object.keys(errors)[0]);
	}

	private getErrorMessage(type: string): string {
		const translations = this.localeService.translations;
		let errorMessage = '';

		switch (type) {
			case ErrorType.PHONE:
				errorMessage = translations['whats-new']['new-auth'][ErrorMessage.PHONE];

				break;
			case ErrorType.PHONE_REQUIRED:
				errorMessage = translations['whats-new']['new-auth'][ErrorMessage.PHONE_REQUIRED];

				break;
			case ErrorType.PHONE_REGISTERED:
				errorMessage = translations['whats-new']['new-auth'][ErrorMessage.PHONE_REGISTERED];

				break;
			case ErrorType.EMAIL:
				errorMessage = ErrorMessage.EMAIL;

				break;
			case ErrorType.REQUIRED:
				errorMessage = ErrorMessage.REQUIRED;

				break;
			default:
				errorMessage = ErrorMessage.DEFAULT;
		}
		return errorMessage;
	}
}
